(() => {
  if (window.__agCartFx) return;
  window.__agCartFx = true;

  const CSS = `
    @keyframes ag-cart-bounce {
      0%   { transform: translateY(0) scale(1); }
      25%  { transform: translateY(-6px) scale(1.15); }
      50%  { transform: translateY(2px) scale(0.95); }
      70%  { transform: translateY(-3px) scale(1.05); }
      100% { transform: translateY(0) scale(1); }
    }
    @keyframes ag-count-pop {
      0%   { transform: scale(1); }
      40%  { transform: scale(1.55); }
      65%  { transform: scale(0.85); }
      100% { transform: scale(1); }
    }
    .ag-cart-bounce {
      animation: ag-cart-bounce 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    }
    .ag-count-pop {
      animation: ag-count-pop 0.35s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    }
  `;

  const style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  const prefersReduced = () =>
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;

  let isFirstFire = true;

  const getCartIcon = () =>
    document.querySelector('cart-icon') ??
    document.querySelector('.header-actions__cart-icon') ??
    document.querySelector('.cart-bubble');

  const getCountEl = (root) => {
    if (!root) return null;
    // If root is the cart-icon custom element, search within; otherwise search globally
    return root.querySelector?.('.cart-bubble__text-count') ??
      document.querySelector('.cart-bubble__text-count');
  };

  const triggerClass = (el, cls) => {
    if (!el) return;
    el.classList.remove(cls);
    // Force reflow so re-adding the class restarts the animation
    void el.offsetWidth;
    el.classList.add(cls);
    const onEnd = () => {
      el.classList.remove(cls);
      el.removeEventListener('animationend', onEnd);
    };
    el.addEventListener('animationend', onEnd);
  };

  document.addEventListener('cart:update', (e) => {
    // Skip first fire (page-load initialisation from some themes)
    if (isFirstFire) {
      isFirstFire = false;
      return;
    }

    if (prefersReduced()) return;

    try {
      const cartIcon = getCartIcon();
      const countEl  = getCountEl(cartIcon);

      triggerClass(cartIcon, 'ag-cart-bounce');
      triggerClass(countEl,  'ag-count-pop');
    } catch (_) {
      // Silently ignore — never break the page
    }
  });
})();
